import { createConsumer } from "@rails/actioncable"

let consumer

export function getConsumer() {
  if (!consumer) consumer = createConsumer()
  return consumer
}

export function subscribeTo(channel, mixin) {
  return getConsumer().subscriptions.create(channel, mixin)
}
